import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Stack, Link, MenuItem, Typography, Container } from '@mui/material';
// locales
import { useLocales } from '@locales';
// components
import LanguageSelection from '../../components/minimal/LanguageSelection';
// hooks
import { useSellerPageContext } from '../../context-state/SellerPageContext';
import { useTermsFormsForAccount } from '../../hooks/useTermsForms';

// ----------------------------------------------------------------------

export default function SellerPageFooter() {
    const { accountContext } = useSellerPageContext();
    const { account } = accountContext;
    const { privacyPolicy, termsOfService } = useTermsFormsForAccount(account);
    const { translate } = useLocales();

    return (
        <Box
            component="footer"
            sx={{
                py: 3,
                px: 2,
                mt: 6,
                backgroundColor: 'background.paper',
                borderTop: (theme) => `1px solid ${theme.palette.divider}`,
            }}
        >
            <Container>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 1, sm: 2 }}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Stack gap={2} direction="row" >
                        {privacyPolicy !== 'hide' && (
                            <Link
                                href={privacyPolicy}
                                target="_blank"
                                rel="noreferrer"
                                variant="body2"
                                color="text.secondary"
                            >
                                {translate('privacy_policy')}
                            </Link>
                        )}
                        {termsOfService !== 'hide' && (
                            <Link
                                href={termsOfService}
                                target="_blank"
                                rel="noreferrer"
                                variant="body2"
                                color="text.secondary"
                            >
                                {translate('terms_of_service')}
                            </Link>
                        )}
                    </Stack>

                    <LanguageSelection variant="body2" color="textSecondary" />
                </Stack>
            </Container>
        </Box>
    );
} 